export const onBackButtonClick = (fallback: VoidFunction) => () => {
    const hasHistory = window.history.length > 1;
    if (hasHistory) {
        history.back();
    } else {
        fallback();
    }
};
